import { jsx as _jsx } from "react/jsx-runtime";
import { Component_MetaPathwayOrder } from './Component_MetaPathwayOrder.js';
import { MUSTNeverHappenException } from '@nu-art/ts-common';
import { ModuleFE_Advisor_Action, ModuleFE_RuntimeOrder } from '@app/advisor-frontend';
import { ICONS } from '@app/styles';
import { RuntimeOrderStatus_Enum } from '@app/advisor-shared';
import { ModuleFE_AdvisorAnalytics } from '../../../../_analytics/consts.js';
import { OrderPlacedSource } from '../../../../_analytics/types.js';
import { getOrderResourceType } from '../../../../_utils/get-resource-type.js';
export class Component_MetaPathwayOrder_General extends Component_MetaPathwayOrder {
    //######################### Life Cycle #########################
    deriveStateFromProps(nextProps, state) {
        state = super.deriveStateFromProps(nextProps, state);
        state.dbOrder = ModuleFE_Advisor_Action.cache.unique(nextProps.rtOrder.orderId);
        if (!state.dbOrder)
            throw new MUSTNeverHappenException(`Could not find order for id ${nextProps.rtOrder.orderId}`);
        state.resourceType = getOrderResourceType(state.dbOrder);
        state.disabled = this.isDisabled(state);
        state.recommended = nextProps.rtOrder.orderStatus === RuntimeOrderStatus_Enum.RECOMMENDED;
        return state;
    }
    //######################### Abstract Logic #########################
    getVariant() {
        if (!this.state.recommended)
            return super.getVariant();
        switch (this.state.resourceType) {
            case 'consult':
                return 'metapathway-order-secondary';
            case 'treatment':
                return 'metapathway-order-tertiary';
            default:
                return 'metapathway-order-primary';
        }
    }
    getIcon = () => {
        switch (this.state.resourceType) {
            case 'consult':
                return _jsx(ICONS.advisor_avn_consultation.component, {});
            case 'ekg':
                return _jsx(ICONS.advisor_avn_ekg.component, {});
            case 'imaging':
                return _jsx(ICONS.advisor_avn_imaging.component, {});
            case 'treatment':
                return _jsx(ICONS.advisor_avn_medication.component, {});
            default:
                return _jsx(ICONS.advisor_avn_labs.component, {});
        }
    };
    getLabel = () => {
        return this.state.dbOrder.name;
    };
    isDisabled(state = this.state) {
        const order = state.dbOrder;
        const isDisabled = !order.variableId || !order.resourceId;
        return super.isDisabled(state) || isDisabled;
    }
    onClick = async () => {
        if (!this.state.recommended)
            return;
        await ModuleFE_RuntimeOrder.orderAll([this.props.rtOrder._id], undefined);
        ModuleFE_AdvisorAnalytics.trigger.orders.order_placed({
            orderId: this.state.dbOrder._id,
            orderLabel: this.state.dbOrder.label ?? this.state.dbOrder.name,
            source: OrderPlacedSource.suggestedWorkup,
        });
    };
    getRuntimeOrderIds = () => {
        return [this.props.rtOrder._id];
    };
}
//# sourceMappingURL=Component_MetaPathwayOrder_General.js.map